export const COUNTRIES = "https://ipapi.co/json/";

export const API_URLS = {
  GOOGLE_LOGIN: "/auth/sign-up-or-login/google",
  GOOGLE_SIGNUP: "/verify-login/user",
  USER_SIGNUP: "/auth/signup/initiate",
  USER_LOGIN: "/auth/login/native",
  ACCEPT_INVITE: "/",
  VERIFY_OTP: "/auth/signup/verify-otp",
  RESEND_OTP: "/auth/signup/resend-otp",
  FORGOT_PASSWORD: "/auth/reset-password/request",
  RESET_PASSWORD: "/auth/reset-password/native",
  CREATE_ORG: "/organisation/add-new-org-details", // google signup with org creation
  CREATE_ORG_SIGNUP: "/auth/signup/organisation", // noraml signup with org creation
  CREATE_USER: "/people/add-new-employee",
  PUBLIC_COUNTRIES: "/public/countries",
  ORGANISATION_SETTINGS: "/organisation/settings",
  PEOPLE_PROFILE_COUNTRIES: "/people/profile/countries",

  GET_ALL_ORG_USERS: (orgUuid: string) =>
    `/organisation/${orgUuid}/get-all-org-admin-pmo-admin-manager-user`,

  // project-management

  PROJECT_BY_ID: '/pmo/get-project',
  PROJECT_WORK_DEFAULTS: '/pmo/get-project-work-defaults',
  GET_CURRENT_USER_DETAILS: '/people/get-current-user-details',

  // resolution
  RESOLVE_PROJECT: (orgSlug: string, projectKey: string) =>
    `/pmo/resolve/${orgSlug}/${projectKey}`,
  RESOLVE_WORK_ITEM: (orgSlug: string, projectKey: string, workItemKey: string) =>
    `/pmo/resolve/work-item/${orgSlug}/${projectKey}/${workItemKey}`,

  // Smart Link metadata
  GET_URL_METADATA: '/get-metadata-from-url',

  // PMO Reports
  PMO_UTILIZATION_LIST: '/pmo/reports/utilization',
  PMO_EMPLOYEE_SUMMARY: (appUserUuid: string) =>
    `/pmo/reports/utilization/${appUserUuid}/summary`,
  PMO_EMPLOYEE_KPIS: (appUserUuid: string) =>
    `/pmo/reports/utilization/${appUserUuid}/kpis`,
  PMO_EMPLOYEE_WORK_ITEMS: (appUserUuid: string) =>
    `/pmo/reports/utilization/${appUserUuid}/work-items`,

  // PMO Team Insights
  PMO_TEAM_INSIGHTS_MEMBERS: '/pmo/team-insights/members',
  PMO_TEAM_INSIGHTS_MEMBER: (appUserUuid: string) =>
    `/pmo/team-insights/members/${appUserUuid}`,
  PMO_TEAM_INSIGHTS_MEMBER_WORK_LOG: (appUserUuid: string) =>
    `/pmo/team-insights/members/${appUserUuid}/work-log`,
  PMO_TEAM_INSIGHTS_MEMBER_ACTIVITY: (appUserUuid: string) =>
    `/pmo/team-insights/members/${appUserUuid}/activity`,

  // PMO Work Schedule
  PMO_WORK_SCHEDULE: '/pmo/capacity/work-schedule',

  // PMO Member Availability
  PMO_MEMBERS: '/pmo/capacity/members',
  PMO_MEMBER: (appUserUuid: string) => `/pmo/capacity/members/${appUserUuid}`,
  PMO_MEMBER_MANUAL: (appUserUuid: string) => `/pmo/capacity/members/${appUserUuid}/manual`,
  PMO_MEMBER_HOLIDAY_CALENDAR: (appUserUuid: string) =>
    `/pmo/capacity/members/${appUserUuid}/holiday-calendar`,
  PMO_MEMBER_ORG_DEFAULT: (appUserUuid: string) =>
    `/pmo/capacity/members/${appUserUuid}/organisation-default`,
  PMO_MEMBER_HRM_ELIGIBILITY: (appUserUuid: string) =>
    `/pmo/capacity/members/${appUserUuid}/hrm-eligibility`,
  PMO_MEMBER_HRM_SYNC: (appUserUuid: string) =>
    `/pmo/capacity/members/${appUserUuid}/hrm-sync`,
  PMO_MEMBER_TIME_OFF: (appUserUuid: string) =>
    `/pmo/capacity/members/${appUserUuid}/time-off`,
  PMO_MEMBER_TIME_OFF_ITEM: (appUserUuid: string, timeOffUuid: string) =>
    `/pmo/capacity/members/${appUserUuid}/time-off/${timeOffUuid}`,

  // PMO Holiday Calendars
  PMO_HOLIDAY_CALENDARS: '/pmo/capacity/holiday-calendars',
  PMO_HOLIDAY_CALENDAR: (calendarUuid: string) =>
    `/pmo/capacity/holiday-calendars/${calendarUuid}`,
  PMO_HOLIDAY_CALENDAR_DEFAULT: (calendarUuid: string) =>
    `/pmo/capacity/holiday-calendars/${calendarUuid}/default`,
  PMO_HOLIDAYS: (calendarUuid: string) =>
    `/pmo/capacity/holiday-calendars/${calendarUuid}/holidays`,
  PMO_HOLIDAY: (calendarUuid: string, holidayUuid: string) =>
    `/pmo/capacity/holiday-calendars/${calendarUuid}/holidays/${holidayUuid}`,
  PMO_HOLIDAYS_COPY: (calendarUuid: string) =>
    `/pmo/capacity/holiday-calendars/${calendarUuid}/holidays/copy`,

  // PMO Convert to Scrum
  PMO_CONVERT_TO_SCRUM: (projectUuid: string) =>
    `/pmo/project/${projectUuid}/convert-to-scrum`,
  PMO_CONVERT_TO_SCRUM_CHECK: (projectUuid: string) =>
    `/pmo/project/${projectUuid}/convert-to-scrum/check`,

  // HRMS Attendance
  ATTENDANCE_TODAY_STATUS: '/hrm/attendance/today-status',
  ATTENDANCE_CHECK_IN: '/hrm/attendance/check-in',
  ATTENDANCE_CHECK_OUT: '/hrm/attendance/check-out',
  ATTENDANCE_MONTHLY_SUMMARY: '/hrm/attendance/monthly-summary',
  ATTENDANCE_CALENDAR_HOVERS: '/hrm/attendance/hovers-calendar',
  ATTENDANCE_DAY_SUMMARY: '/hrm/attendance/day-summary',
  GET_EMPLOYEES_ATTENDANCE: '/hrm/attendance/get-employees/attendance',
  UPDATE_ATTENDANCE_RECORD: (attendanceRecordUuid: string) =>
    `/hrm/attendance/update/attendance-record/${attendanceRecordUuid}`,
  CREATE_MISSED_ATTENDANCE: (employeeUuid: string) =>
    `/hrm/attendance/create/attendance-record/${employeeUuid}`,
};

